import { Outlet, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";

function Layout() {
  const navigate = useNavigate();
  return (
    <>
      <div className="m-2">
        <Button
          variant="primary"
          onClick={() => {
            navigate("/");
          }}
        >
          Home
        </Button>
        <Button
          style={{ marginLeft: "10px" }}
          variant="primary"
          onClick={() => {
            navigate("/cost");
          }}
        >
          Cost
        </Button>
        <Button
          style={{ marginLeft: "10px" }}
          variant="primary"
          onClick={() => {
            navigate("/webhook");
          }}
        >
          Webhook
        </Button>
        <span style={{ marginLeft: "10px" }}>
          {" "}
          <b>Last updated:</b> 02/May/2024
        </span>
      </div>
      <div id="detail">
        <Outlet />
      </div>
    </>
  );
}

export default Layout;
